import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "../utils";

export interface ChatMessage {
  from: "User" | "Bot";
  message: string;
}

export const useVenturiPublicChatQuery = (chatId: string) => {
  const { isLoading, data, error } = useQuery({
    queryKey: QueryKeys.venturiPublicChat(chatId),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    enabled: true,
    /*async*/ queryFn() {
      const placeholder: ChatMessage[] = [];

      return placeholder;
    },
  });

  return {
    venturiPublicChatLoading: isLoading,
    venturiPublicChat: data ?? null,
    venturiPublicChatError: error ?? null,
  };
};
